import styled from 'styled-components';

import { useTranslation } from '@hooks';
import { H3, Text2 } from '@components/styles/Typography';

const CookiePartnerDetail = ({
    facebook,
    pixel,
    gAnalytics,
    gTagManager,
    gReMarketing,
}) => {
    const { t } = useTranslation();
    if (facebook) return <Text2>{t('facebookText')}</Text2>;
    if (pixel) return <Text2>{t('pixelText')}</Text2>;
    if (gAnalytics) return <Text2>{t('gAnalyticsText')}</Text2>;
    if (gTagManager) return <Text2>{t('gTagManagerText')}</Text2>;
    if (gReMarketing) return <Text2>{t('gReMarketingText')}</Text2>;
    return (
        <Wrapper>
            <H3>{t('consentPurposes')}</H3>
            <ul>
                <li>
                    <Text2>{t('consentPurpose1')}</Text2>
                </li>
                <li>
                    <Text2>{t('consentPurpose2')}</Text2>
                </li>
                <li>
                    <Text2>{t('consentPurpose3')}</Text2>
                </li>
                <li>
                    <Text2>{t('consentPurpose4')}</Text2>
                </li>
                <li>
                    <Text2>{t('consentPurpose5')}</Text2>
                </li>
            </ul>
            <H3>{t('specialPurposes')}</H3>
            <ul>
                <li>
                    <Text2>{t('specialPurpose1')}</Text2>
                </li>
                <li>
                    <Text2>{t('specialPurpose2')}</Text2>
                </li>
            </ul>
            <H3>{t('features')}</H3>
            <ul>
                <li>
                    <Text2>{t('feature1')}</Text2>
                </li>
                <li>
                    <Text2>{t('feature2')}</Text2>
                </li>
            </ul>
        </Wrapper>
    );
};
const Wrapper = styled.div`
    margin-top: 20px;
    ul {
        list-style: circle;
    }
`;
export default CookiePartnerDetail;
